// store.js
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    url_end_point:'https://mxrealestate.montrix.co.kr', 
    //url_end_point:'http://127.0.0.1:5000', 
    test: process.env.NODE_ENV,
    isHeaderVisible: true,
    userinfo: {
      email: "Guest"
    },
    selected_portfolio: {
      title: "default",
      position_list: []
    },
    position_cookie : 'position_token',
    new_position_info_template: {
        name: "부동산",
        asset_type: "apartment",
        address: "주소 확인 필요함",
        legal_dong: "test dong",
        apt_name: "test apt",
        private_area: 55.12,
        region_code: 11110,
        book_value: 10000,
        book_date: "2018-10-11",
        //position_type: 0, // 0 : owner_occupied, // 1: rent
        position_type: "자가거주", // 1: rent
        rent: {
          deposit: 0,
          monthly_payment: 1000,
          effective_date: "2018-10-11",
          maturity_date: "2018-10-11"
        },
        loan_type: '없음', // '고정금리', '변동금리'
        loan: {
          amount: 0,
          rate: 0.03,
          effective_date: "2018-10-11",
          maturity_date: "2018-10-11"
        }
    },
    
    results_data: {
      name: "not calculated",
      result_date: 'Not Calulated',
      summary: {
        asset_amount: "-", // 현재가
        liability_amount: "-",
        capital_amount: "-",
        profit_percent: "-",
        profit_amount: "-"
      },
      flows: {
        dates: ["2018-10-11", "2018-10-11"],
        inflows: [100, 100],
        outflows: [100, 100]
      },
      comments: {},
      timestamp: ''
    },
    isCalculated: false,
    mainstep: 0,
  },
  getters: {
    position_list: state => {
      return state.selected_portfolio.position_list;
    },
    getCookie: state => (name) => {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0){
          var cookie = c.substring(nameEQ.length, c.length);
          
          return cookie;
        } 
        
      }
      return null;

    }

  }
});
